export default {
  name: 'HubIcon',
  props: {
    name: {
      type: String,
      default: 'arrow'
    }
  }
};